<ion-app>
    <app-navbar></app-navbar>
    <div *ngIf="theme.name == 'LabInfo' && appConfigs.banner_message.show" id="important_messages">
      <p *ngIf="lang == 'en'"> {{appConfigs["banner_message"]["message"]["en"] }} </p>
      <p *ngIf="lang == 'es'"> {{appConfigs["banner_message"]["message"]["es"] }} </p>
    </div>
    <app-notify-banner></app-notify-banner>
    <ngx-loading-bar [fixed]="false" [includeSpinner]="false" color="var(--orange)" height="5px"></ngx-loading-bar>

  <ion-content>
    <div class="wrapper">
      <router-outlet></router-outlet>
    </div>
  </ion-content>

  <div *ngIf="updating" style="z-index: 2"
      class="position-fixed bg-white w-100 h-100 d-flex justify-content-center align-items-center">
    <div class="position-relative">
      <img id="loader" src="../assets/patientlynk/img/SVG/icon.svg" style="width: 250px">
      <div class="position-absolute d-flex flex-column justify-content-center w-100 text-center pt-5">
        <span>Downloading...</span>
      </div>
    </div>
  </div>
</ion-app>
